import React, {
  FC,
  useRef,
  useEffect,
  useContext,
  useMemo,
  useState,
} from 'react'
import classNames from 'classnames'
import { Controller, useForm } from 'react-hook-form'
import TextareaAutosize from 'react-textarea-autosize'

type ChatInputProps = {
  // scrollAtEnd: boolean
  addMessage: any
}

export type FormType = {
  content: string
}

const defaultValues: FormType = {
  content: '',
}

let ChatInput: FC<ChatInputProps> = ({ addMessage }) => {
  const inputRef = useRef<HTMLTextAreaElement>()

  const { handleSubmit, getValues, watch, reset, setValue, control } =
    useForm<FormType>({
      defaultValues: defaultValues,
      mode: 'onChange',
    })

  const [disabledSubmit, setDisabledSubmit] = useState(true)

  const submit = handleSubmit(async ({ content }) => {
    if (disabledSubmit) {
      return
    }

    addMessage(content)

    reset(defaultValues)
  })

  useEffect(() => {
    const { content } = getValues()
    content ? setDisabledSubmit(false) : setDisabledSubmit(true)
  }, [watch('content')])

  return (
    <form
      onSubmit={submit}
      className={classNames('chat-input', {
        // 'is-scrollAtEnd': scrollAtEnd,
      })}
    >
      <div
        className={classNames('chat-input-textarea')}
        onClick={() => {
          inputRef.current && inputRef.current.focus()
        }}
      >
        <Controller
          name="content"
          control={control}
          render={renderProps => (
            <TextareaAutosize
              id="main-input"
              onKeyDown={e => {
                if (e.key == 'Enter' && !e.shiftKey) {
                  e.preventDefault()
                  submit()
                }
              }}
              rows={1}
              minRows={1}
              maxRows={10}
              {...renderProps.field}
              ref={ref => {
                renderProps.field.ref(ref)
                inputRef.current = ref!
              }}
            />
          )}
        />
        <div className="chat-input-buttons-wrapper">
          <div className="chat-input-buttons">
            <div className="chat-input-buttons-group">
              <button
                className="is-send"
                type="submit"
                disabled={disabledSubmit}
              >
                <span className="fa fa-paper-plane-top" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

export default ChatInput
